"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockedPickAndPackDatesManager = void 0;
const moment_1 = __importDefault(require("moment"));
class BlockedPickAndPackDatesManager {
    constructor() {
        this.blockedPickAndPackRules = {};
    }
    add(deliveryRule) {
        const key = deliveryRule.getKey();
        if (!key) {
            return;
        }
        this.blockedPickAndPackRules[key] = deliveryRule;
    }
    remove(deliveryRule) {
        const key = deliveryRule.getKey();
        if (!key) {
            return;
        }
        delete this.blockedPickAndPackRules[key];
    }
    get(key) {
        return this.blockedPickAndPackRules[key] || null;
    }
    getBlockedDeliveryPickAndPackDates() {
        return this.blockedPickAndPackRules;
    }
    getNrOfBlockedPickAndPackDatesManagerBetween(fromDate, untilDate) {
        if (!fromDate || !untilDate) {
            return 0;
        }
        if (fromDate >= untilDate) {
            return 0;
        }
        let count = 0;
        for (let date = (0, moment_1.default)(fromDate); date.isBefore(untilDate); date.add(1, 'days')) {
            const dateString = date.format('YYYY-MM-DD');
            if (this.blockedPickAndPackRules[dateString]) {
                count++;
            }
        }
        return count;
    }
    getAllRules() {
        return Object.values(this.blockedPickAndPackRules);
    }
}
exports.BlockedPickAndPackDatesManager = BlockedPickAndPackDatesManager;
